const LOGIN_HINT_MAIL = 'pendingLoginHintMail';
const LOGIN_HINT_MAX_AGE_MS = 5 * 60 * 1000;

interface PendingLoginHint {
  mail: string;
  createdAt: number;
}

export function setPendingLoginHint(mail: string): void {
  const hint: PendingLoginHint = { mail, createdAt: Date.now() };
  localStorage.setItem(LOGIN_HINT_MAIL, JSON.stringify(hint));
}

/** Reads and clears: an abandoned logout must not prefill the login of whoever uses this browser next. */
export function consumePendingLoginHint(): string | undefined {
  const stored = localStorage.getItem(LOGIN_HINT_MAIL);
  localStorage.removeItem(LOGIN_HINT_MAIL);
  if (!stored) {
    return undefined;
  }

  const hint = parseLoginHint(stored);
  if (!hint || Date.now() - hint.createdAt > LOGIN_HINT_MAX_AGE_MS) {
    return undefined;
  }
  return hint.mail;
}

export function clearPendingLoginHint(): void {
  localStorage.removeItem(LOGIN_HINT_MAIL);
}

export function loginHintExtras(mail: string | undefined): { extras: { login_hint: string } } | undefined {
  return mail ? { extras: { login_hint: mail } } : undefined;
}

function parseLoginHint(stored: string): PendingLoginHint | undefined {
  try {
    const parsed: unknown = JSON.parse(stored);
    if (typeof parsed !== 'object' || parsed === null) {
      return undefined;
    }
    const { mail, createdAt } = parsed as Partial<PendingLoginHint>;
    return typeof mail === 'string' && typeof createdAt === 'number' ? { mail, createdAt } : undefined;
  } catch {
    return undefined;
  }
}
